<template>
    <div>
        <b-form-group label="Nº Serie" label-for="client">
            <b-form-input v-model="localSerialNumber" placeholder="Nº Serie" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" className="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        serialNumber: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localSerialNumber: {
            get() {
                return this.serialNumber
            },
            set(value) {
                this.$emit('update', {serial_number: value})
            },
        },
    },
}
</script>
